import SSOActions from './constants';
import { IActionObject } from './types';

export function initializeSSOWithParams(ssoData: object): IActionObject {
  return { type: SSOActions.SET_SSO_PARAMS, data: { ssoData } };
}

export default {
  initializeSSOWithParams,
};
try {
    // @ts-ignore
    initializeSSOWithParams.displayName = "initializeSSOWithParams";
    // @ts-ignore
    initializeSSOWithParams.__docgenInfo = { "description": "", "displayName": "initializeSSOWithParams", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/store/SSO/actions.ts#initializeSSOWithParams"] = { docgenInfo: initializeSSOWithParams.__docgenInfo, name: "initializeSSOWithParams", path: "src/store/SSO/actions.ts#initializeSSOWithParams" };
}
catch (__react_docgen_typescript_loader_error) { }